import { render, staticRenderFns } from "./LiveExpiryBadgeState.vue?vue&type=template&id=0dd62f7e&"
import script from "./LiveExpiryBadgeState.vue?vue&type=script&lang=js&"
export * from "./LiveExpiryBadgeState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports